import React from "react";
import { getTheme } from "../../styled/theme";
import type { pronounceFeedbackQuery } from "../../queries/stt/__generated__/pronounceFeedbackQuery.graphql";
import styled from "styled-components/macro";

export type LetterAnalysisType = NonNullable<
  NonNullable<pronounceFeedbackQuery["response"]["pronounceFeedback"]>["letter_analysis"]
>;

type Props = {
  letterAnalysis: LetterAnalysisType | undefined;
  fontSize?: string;
  className?: string;
  themeName?: "default" | "sepia";
};

const Container = styled.span`
  display: flex;
  flex-wrap: wrap; /* allow letters to wrap to next line */
  white-space: pre-wrap; /* preserve spaces but permit wrapping */
  margin-right: 10px; /* keep clear of the close (X) icon */
`;

const Letter = styled.span<{ $color: string }>`
  color: ${({ $color }) => $color};
  font-size: 14px;
  font-weight: 700;
  transition: color 0.2s;
  white-space: pre;
`;

const LetterFeedback: React.FC<Props> = ({ letterAnalysis, className, themeName = "default" }) => {
  const theme = getTheme(themeName);
  const normalized = Array.isArray(letterAnalysis)
    ? letterAnalysis.filter(
        (l): l is { letter: string; score: number } =>
          !!l && typeof l.letter === "string" && typeof l.score === "number"
      )
    : [];

  return (
    <Container>
      {normalized.map(({ letter, score }, idx) => {
        let color: string = "inherit";
        if (letter !== " ") color = score <= 70 ? theme.color.red : theme.color.green;
        return (
          <Letter key={idx} $color={color}>
            {letter}
          </Letter>
        );
      })}
    </Container>
  );
};

export default LetterFeedback;
